import { api } from './config/axios';
import { store } from '../store';

export const getServices = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/services', {}, config);
};

export const updateServiceImages = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/update-services-images', payload, config);
};

export const getServicesAvailability = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/system/service-availability', {}, config);
};

export const getCategoriesAvailability = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/system/category-availability', {}, config);
};

export const getAppSetting = async () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/app-setting', {}, config);
};

export const updateAppSetting = async (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.put('/api/v1/admin/app-setting', payload, config);
};

export const changeServicesAvailability = (serviceId, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/system/service-availability/${serviceId}`, payload, config);
};

export const changeCategoryAvailability = (categoryId, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/system/category-availability/${categoryId}`, payload, config);
};

export const getCurrentProcessor = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/processor', {}, config);
};

export const updateCurrentServiceProcessor = (processor) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const payload = { processor: { name: processor } };

  return api.post('/api/v1/admin/processor', payload, config);
};

export const getCurrentDiscount = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/discount', {}, config);
};

export const updateCurrentServiceDiscount = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.post('/api/v1/admin/discount', payload, config);
};

export const updateServices = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/services/update', payload, config);
};

export const regenerateResellingServices = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/reselling/services/regenerate', payload, config);
};

export const createResellingApiService = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/reselling/services', payload, config);
};

export const getProcessors = (query = {}) => api.get('/api/v1/admin/current-processors', query);

export const getProcessorProduct = async (processor) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.get('/api/v1/admin/current-processor-product', { processor }, config);
};

export const createNewProduct = async (payload, processor) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.post(`/api/v1/admin/services?processor=${processor}`, payload, config);
};

export const deleteProduct = async (productId) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return api.delete(`/api/v1/admin/services/${productId}`, {}, config);
};

export const uploadDashboardImage = async (data) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };

  return api.post('/api/v1/admin/upload-advert-asset', data, config);
};
